import {
    BASE_URL, 
    POST,  
    INCIDENT_COMMENTS,
    GET,
    PAGE_SIZE
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const addIncidentCommentRequest = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${INCIDENT_COMMENTS}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  

  export const fetchIncidentComments = async (requestId,next,pageSize=PAGE_SIZE) => {
    const token = await getAccessToken();    
    let url = `${BASE_URL}${INCIDENT_COMMENTS}`;
    let paramsArray = [
      { key: "incidentId", value: requestId },
      { key: "next", value: next },
      { key: "pageSize", value: pageSize }
  ];
  let queryString = paramsArray
        .filter(item => item.value)
        .map(item => `${item.key}=${encodeURIComponent(item.value)}`)
        .join('&');
    if (queryString) {
        url = `${url}?${queryString}`;
    }
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };